module.exports = __webpack_public_path__ + "img/crm3.55c16bc6.png";